import React from 'react';
import PropTypes from 'prop-types';
import {Button, Card, Radio} from 'lark';
import ImgIcon from '~/component/ImgIcon';
import Mask from '~/layout/Mask';
import './index.less';

const WebHelpCenter = props => {
    const {children, onChange, onClose, radio} = props;
    return (
        <Mask>
            <div className="web-help-wrapper">
                <Card
                    title="帮助中心"
                    class="help-card"
                    extra={(
                        <Button
                            type="link"
                            onClick={onClose}
                        >
                            <ImgIcon type="close" />
                        </Button>
                    )}
                >
                    <nav className="help-nav">
                        <Radio.Group onChange={onChange} value={radio}>
                            <Radio.Button value="login">登录</Radio.Button>
                            <Radio.Button value="safe">安全验证</Radio.Button>
                        </Radio.Group>
                    </nav>
                    <main className="help-main">
                        {children}
                    </main>
                </Card>
            </div>
        </Mask>
    );
};

WebHelpCenter.propTypes = {
    children: PropTypes.shape().isRequired,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    radio: PropTypes.string.isRequired,
};


export default WebHelpCenter;
